<template>
  <div style="margin-top: 10px">
    <el-form :model="formData" label-width="200px" :rules="rules">

      <el-row >
        <el-col  :span="11" >
          <el-form-item label="设备类型：" prop="star1">
            <el-select v-model="formData.device_id"   placeholder="设备类型" clearable style="width: 250px">
              <el-option v-for="dict in eqDeviceTypeAll" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col  :span="11" >
          <el-form-item label="部位名称：" prop="star2">
            <el-select v-model="formData.position_id" @change="getPositionAll"  placeholder="部位名称" clearable style="width: 250px">
              <el-option v-for="dict in eqPositionTypeAll" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col  :span="24" >
          <div style="margin-left: 90px">
            <span>保养标准方法：&nbsp;&nbsp;&nbsp;共&nbsp;<span style="color:#0486fe;">{{formData.standardList.length}}</span>&nbsp;项</span>
          </div>
        </el-col>
      </el-row>

      <div style="margin-top: 10px">
        <el-row class="box">
          <el-col :span="2">
            <el-icon @click="addOneProjectDescribe()" color="#0486fe" size="25" style="cursor: pointer;margin-left: -110px;margin-top: 5px" ><ElIconCirclePlusFilled /></el-icon>
          </el-col>
          <el-col  :span="2" style="padding-right: 10px">编号</el-col>
          <el-col  :span="8" style="padding-right: 10px">保养标准方法</el-col>
          <el-col  :span="12" style="padding-right: 10px">报告项</el-col>
        </el-row>

        <el-row v-for="(item,index) in formData.standardList" :key="index" class="row">
          <el-col :span="2" style="padding-right: 10px">
            <spna>{{index+1}}</spna>
          </el-col>

          <el-col :span="8" style="padding-right: 10px">
            <el-input v-model="item.maintenance_method"  placeholder="保养标准方法"></el-input>
          </el-col>

          <el-col :span="14">
            <el-checkbox name="time_consuming" value=true v-model="item.time_consuming" disabled  label="耗时（分）" />
            <el-radio-group v-model="item.pm_type">
              <el-radio value="replace_part" label="replace_part">更换部品</el-radio>
              <el-radio value="oil_usage" label="oil_usage">油品用量</el-radio>
            </el-radio-group>
          </el-col>

          <div class="close" @click="removeOneProjectDescribe(item.nanoid)">
            <el-icon color="red" size="25"><ElIconRemove /></el-icon>
          </div>
        </el-row>

        <div style="margin-top: 20px;text-align: center">
          <el-button color="#0486fe" style="width: 100px" @click="addPosition" :loading="loading">提交</el-button>
        </div>

        <div style="height: 40px">

        </div>
      </div>

    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "EqStandardZhiZaoAdd",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        device_id: '',
        position_id: '',
        standardList: [],
      },
      eqDeviceTypeAll: [],
      eqPositionTypeAll: [],
      rules: {
        star1: [{required: true, message: '', trigger: 'blur'}],
        star2: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {

  },
  methods:{
    addFiveProjectDescribe() {
      for (let i = 0; i < 1; i++) {
        this.formData.standardList.push({
          nanoid: nanoid(),
          time_consuming: true
        })
      }
    },
    addOneProjectDescribe() {
      this.formData.standardList.push({
        nanoid: nanoid(),
        time_consuming: true
      })
      this.formData.num = this.formData.standardList.length
    },
    removeOneProjectDescribe(nanoid) {
      let index = this.formData.standardList.findIndex(item => item.nanoid === nanoid);
      this.formData.standardList.splice(index, 1);
      this.formData.num = this.formData.standardList.length
    },
    async getEqDeviceTypeAll() {
      let {data: res} = await this.$axios.get('/eq/maintenancePosition/getEqDeviceTypeAll');
      this.eqDeviceTypeAll = res.data;
    },
    async getEqPositionTypeAll() {
      let {data: res} = await this.$axios.get('/eq/position/getEqPositionTypeAll');
      this.eqPositionTypeAll = res.data;
    },
    getPositionAll() {
      if (!this.formData.device_id) {
        return this.$message.error('设备类型不能为空!')
      }

      if (!this.formData.position_id) {
        return this.$message.error('部品名称不能为空!')
      }

      this.$axios.post('eq/position/getPositionAll', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.formData.standardList = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    addPosition(){
      if (!this.formData.device_id) {
        return this.$message.error('设备类型不能为空!')
      }

      if (!this.formData.position_id) {
        return this.$message.error('部品名称不能为空!')
      }

      this.loading = true;
      this.$axios.post('eq/position/addPosition', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('添加成功!');
      })
    }

  },created() {
    this.addFiveProjectDescribe()
    this.getEqDeviceTypeAll()
    this.getEqPositionTypeAll()
  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 650px;
  margin-left: 80px
}
.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
.row {
  margin-left: 80px;
  width: 650px;
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
</style>